import {
  Button,
  DatePicker,
  Form,
  PageHeader,
  Row,
  Select,
  Radio,
  Breadcrumb,
  Popconfirm,
  Col,
  Input,
  message,
  Spin,
  InputNumber,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { CSVLink } from "react-csv";
import moment from "moment";
import Page from "_components/Page";
import { Auth, ReceiptType } from "_helpers";
import {
  companyService,
  extraService,
  sbuService,
  stockClassificationService,
  subLocationService,
  zoneService,
  vehicleService,
  jobService,
  stockReceiptService,
} from "_services";

const useQuery = () => new URLSearchParams(useLocation().search);

const AddViaJob = ({ history }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const [storeAddresses, setStoreAddresses] = useState([]);
  const [customers, setcustomers] = useState([]);
  const [customerAddresses, setcustomerAddresses] = useState([]);
  const [selectedcustomer, setSelectedcustomer] = useState(null);
  const [stores, setStores] = useState([]);
  const [materialSuppliers, setMaterialSuppliers] = useState([]);
  const [isDetailedUpload, setIsDetailedUpload] = useState(Date());
  const [base64File, setBase64File] = useState(null);
  const [originalFileName, setOriginalFileName] = useState(null);
  const [stockClasses, setStockClasses] = useState([]);
  const [inProgressJobs, setInProgressJobs] = useState([]);
  const [jobTasks, setJobTasks] = useState([]);
  const [subLocations, setSubLocations] = useState([]);
  const [selectedSbuId, setSelectedSbuId] = useState(null);
  const [selectedZoneId, setSelectedZoneId] = useState(null);
  const [error, setError] = useState(null);
  const [vehicles, setVehicles] = useState([]);
  const query = useQuery();

  const [form] = Form.useForm();
  const { Option } = Select;
  const { TextArea } = Input;
  const loggedInCustomerCode = Auth.getProfile().comp_code;
  const isLoggedInCustomer = () => {
    return Auth.hasRole(Auth.getProfile(), ["CAU"]);
  };

  useEffect(() => {
    getInProgressJobs();
  }, []);

  const getJobTasks = (jobId) => {
    form.resetFields(["task"]);

    const selectedJob = inProgressJobs.find((item) => item.id === jobId);
    if (selectedJob) {
      const allTasks = selectedJob.workItems.flatMap((workItem) =>
        workItem.jobTasks.map((task) => ({
          ...task,
        }))
      );
      setJobTasks(allTasks);
    }
  };

  const getInProgressJobs = () => {
    setIsLoading(true);
    jobService
      .search("?jobStatus=IN_PROGRESS")
      .then((x) => {
        setIsLoading(false);
        setInProgressJobs(x.content);
        if (query.get("jobId")) {
          const selectedJob = x.content.find(
            (item) => item.id === query.get("jobId")
          );
          if (selectedJob) {
            const allTasks = selectedJob.workItems.flatMap((workItem) =>
              workItem.jobTasks.map((task) => ({
                ...task,
              }))
            );
            form.setFieldsValue({ job: selectedJob });
          }
        }
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const handleFormSumbit = () => {
    form
      .validateFields()
      .then((values) => {
        setIsLoading(true);

        const payload = {
          jobTask: values.task,
          completedQuantity: values.completedQuantity,
          remark: values.remark,
          receivedDate: moment(values.receivedDate).format("YYYY-MM-DD"),
          receiptType: values.receiptType,
        };

        //console.log("PL: ", payload);
        stockReceiptService
          .createViaJobTask(payload)
          .then(() => {
            message.success("Successfully created!");
            setIsLoading(false);
            history.push("/stock-receipts");
          })
          .catch((error) => {
            setIsLoading(false);
            setError(error);
          });
      })
      .catch((error) => {
        //message.error(`${error}`);
      });
  };

  const onCancel = () => {
    history.push("/stock-receipts");
  };

  const onFileChange = (e) => {
    if (e.target.files[0]) {
      setOriginalFileName(e.target.files[0].name);
      let reader = new FileReader();
      reader.onload = function (e) {
        setBase64File(reader.result);
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const getActionButtons = () => {
    let buttons = [];

    buttons.push(
      <Popconfirm
        title="Are you sure to add the changes?"
        onConfirm={handleFormSumbit}
        key="add-confirm"
      >
        <Button key="save" type="primary" htmlType="submit" loading={isLoading}>
          Save
        </Button>
      </Popconfirm>
    );
    buttons.push(
      <Button key="cancel" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );

    return buttons;
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/stock-receipts">Stock Receipt Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Stock Receipt via Job Task</Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner error={error}>
          <Spin tip="Loading..." spinning={isLoading}>
            <Form
              layout="vertical"
              form={form}
              name="form-create"
              requiredMark={false}
            >
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name={["job", "id"]}
                    label="Job"
                    rules={[{ required: true, message: "Job is required" }]}
                  >
                    <Select
                      placeholder="Please select"
                      allowClear
                      onChange={getJobTasks}
                    >
                      {inProgressJobs.length > 0 &&
                        inProgressJobs.map((t) => (
                          <Option value={t.id} key={t.id}>
                            {t.code}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name={["task", "id"]}
                    label="Task"
                    rules={[{ required: true, message: "Task is required" }]}
                  >
                    <Select placeholder="Please select" allowClear>
                      {jobTasks.length > 0 &&
                        jobTasks.map((t) => (
                          <Option value={t.id} key={t.id}>
                            {t.code}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="receivedDate"
                    label="Received Date"
                    rules={[
                      { required: true, message: "Received date is required" },
                    ]}
                    initialValue={moment()}
                  >
                    <DatePicker
                      placeholder="Received date"
                      format="YYYY-MM-DD"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="completedQuantity"
                    label="Completed Quantity"
                    rules={[
                      {
                        required: true,
                        message: "Completed Quantity is required.",
                      },
                    ]}
                  >
                    <InputNumber />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name="receiptType"
                    label="Receipt Type"
                    rules={[
                      {
                        required: true,
                        message: "Receipt Type is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      allowClear
                      showArrow={false}
                      optionFilterProp="children"
                      placeholder="Receipt Type"
                    >
                      {ReceiptType.map((t) => (
                        <Select.Option value={t.value} key={t.value}>
                          {t.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="remark" label="Remark">
                    <TextArea />
                  </Form.Item>
                </Col>
                <Col span={12}></Col>
              </Row>
            </Form>
          </Spin>
        </Page>
      </PageHeader>
    </div>
  );
};

export default AddViaJob;
